import {
  currentOrPastDateUI,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['insurance-info--medicare-details-title'];
const DESC_TEXT = content['insurance-info--medicare-details-description'];
const INPUT_LABELS = {
  effectiveDate: content['insurance-info--medicare-details-date-label'],
  claimNumber: content['insurance-info--medicare-details-number-label'],
};
const HINT_TEXT = {
  effectiveDate: content['insurance-info--medicare-details-date-hint'],
  claimNumber: content['insurance-info--medicare-details-number-hint'],
};
const ERR_MSGS = {
  claimNumber: { required: content['validation-error--medicare-number'] },
};

const { medicarePartAEffectiveDate, medicareClaimNumber } =
  FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    medicareClaimNumber: textUI({
      title: INPUT_LABELS.claimNumber,
      hint: HINT_TEXT.claimNumber,
      errorMessages: ERR_MSGS.claimNumber,
    }),
    medicarePartAEffectiveDate: currentOrPastDateUI({
      title: INPUT_LABELS.effectiveDate,
      hint: HINT_TEXT.effectiveDate,
    }),
  },
  schema: {
    type: 'object',
    required: ['medicareClaimNumber', 'medicarePartAEffectiveDate'],
    properties: {
      medicareClaimNumber,
      medicarePartAEffectiveDate,
    },
  },
};
